/**
 * Notification message come directly from IFeatureMessageClient on the gateway.
 */
export interface NotificationMessage {
    /**
     * Gets or sets the identity of notification message.
     */
    id: string;

    /**
     * Gets or sets the started time. Set only when initially created a notification otherwise set to null.
     */
    beginTime?: string;

    /**
     * Gets or sets the instance time. Set always with current source time.
     */
    instanceTime: string;

    /**
     * Gets or sets the completed time. Set when the notification message is completed or error'ed out.
     */
    endTime?: string;

    /**
     * Gets or sets the notification error level.
     */
    errorLevel: number | string;

    /**
     * The title.
     */
    title: string;

    /**
     * The message.
     */
    message: string;

    /**
     * The notification source type.
     */
    sourceType: number;

    /** <summary>
     * The notification source name.
     */
    sourceName: string;
}
